import {
  PostGalleryImageInterface,
  DeleteGalleryImageInterface,
} from '@/data/payload/contracts/GalleryImageRequest'

export class DeleteGalleryImageRequest implements DeleteGalleryImageInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class GalleryImageApiRequest implements PostGalleryImageInterface {
  private name: string
  private category: string
  private fileByte: string
  private fileUpload: any

  constructor(
    name: string,
    category: string,
    fileByte: string,
    fileUpload: any
  ) {
    this.name = name
    this.category = category
    this.fileByte = fileByte
    this.fileUpload = fileUpload
  }

  public toJSON() {
    const data = {
      name: this.name,
      category: this.category,
      file_byte: this.fileByte,
    }

    return JSON.stringify({
      data,
    })
  }

  public toFormData() {
    const data = new FormData()
    data.append('name', this.name)
    data.append('category', this.category)
    data.append('fileUpload', this.fileUpload)
    return data
  }
}
